import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/styles.css.ts", "@paypalcorp/pp-react-icons");
import { style, globalStyle } from '@vanilla-extract/css';
import { tokens } from '@paypalcorp/pp-react-theme';
export const legalColors = {
  sysColorBackgroundMain: tokens.color.background.main,
  sysColorBackgroundAlt: tokens.color.background.alt,
  sysColorBackgroundSurface: tokens.color.background.surface,
  sysColorBackgroundSurfaceHover: tokens.color.background.surfaceHover,
  sysColorBackgroundSurfaceActive: tokens.color.background.surfaceActive,
  sysColorBackgroundHighContrast: tokens.color.background.highContrast,
  sysColorBackgroundMediumContrast: tokens.color.background.mediumContrast,
  sysColorPrimaryMain: tokens.color.primary.main,
  sysColorPrimaryMainHover: tokens.color.primary.mainHover,
  sysColorPrimaryMainActive: tokens.color.primary.mainActive,
  sysColorPrimaryContrast: tokens.color.primary.contrast,
  sysColorPrimaryContrastHover: tokens.color.primary.contrastHover,
  sysColorPrimaryContrastActive: tokens.color.primary.contrastActive,
  sysColorSecondaryMain: tokens.color.secondary.main,
  sysColorSecondaryMainHover: tokens.color.secondary.mainHover,
  sysColorSecondaryMainActive: tokens.color.secondary.mainActive,
  sysColorSecondaryContrast: tokens.color.secondary.contrast,
  sysColorTertiaryMain: tokens.color.tertiary.main,
  sysColorTertiaryMainHover: tokens.color.tertiary.mainHover,
  sysColorTertiaryMainActive: tokens.color.tertiary.mainActive,
  sysColorTertiaryContrast: tokens.color.tertiary.contrast,
  sysColorFeaturedMain: tokens.color.featured.main,
  sysColorFeaturedMainHover: tokens.color.featured.mainHover,
  sysColorFeaturedMainActive: tokens.color.featured.mainActive,
  sysColorFeaturedContrast: tokens.color.featured.contrast,
  sysColorUnselectedMain: tokens.color.unselected.main,
  sysColorUnselectedMainHover: tokens.color.unselected.mainHover,
  sysColorUnselectedMainActive: tokens.color.unselected.mainActive,
  sysColorUnselectedContrast: tokens.color.unselected.contrast,
  sysColorSelectedMain: tokens.color.selected.main,
  sysColorSelectedMainHover: tokens.color.selected.mainHover,
  sysColorSelectedMainActive: tokens.color.selected.mainActive,
  sysColorSelectedContrast: tokens.color.selected.contrast,
  sysColorSelectedRangeMain: tokens.color.selectedRange.main,
  sysColorSelectedRangeMainHover: tokens.color.selectedRange.mainHover,
  sysColorSelectedRangeMainActive: tokens.color.selectedRange.mainActive,
  sysColorSelectedRangeContrast: tokens.color.selectedRange.contrast,
  sysColorLinkMain: tokens.color.link.main,
  sysColorLinkMainHover: tokens.color.link.mainHover,
  sysColorLinkMainActive: tokens.color.link.mainActive,
  sysColorLinkAlt: tokens.color.link.alt,
  sysColorLinkAltHover: tokens.color.link.altHover,
  sysColorLinkAltActive: tokens.color.link.altActive,
  sysColorLinkContrast: tokens.color.link.contrast,
  sysColorLinkContrastHover: tokens.color.link.contrastHover,
  sysColorLinkContrastActive: tokens.color.link.contrastActive,
  sysColorAccent1Main: tokens.color.accent1.main,
  sysColorAccent1Contrast: tokens.color.accent1.contrast,
  sysColorAccent2Main: tokens.color.accent2.main,
  sysColorAccent2Contrast: tokens.color.accent2.contrast,
  sysColorAccent3Main: tokens.color.accent3.main,
  sysColorAccent3Contrast: tokens.color.accent3.contrast,
  sysColorAccent4Main: tokens.color.accent4.main,
  sysColorAccent4Contrast: tokens.color.accent4.contrast,
  sysColorErrorMain: tokens.color.error.main,
  sysColorErrorMainHover: tokens.color.error.mainHover,
  sysColorErrorMainActive: tokens.color.error.mainActive,
  sysColorErrorContrast: tokens.color.error.contrast,
  sysColorWarningMain: tokens.color.warning.main,
  sysColorWarningMainHover: tokens.color.warning.mainHover,
  sysColorWarningMainActive: tokens.color.warning.mainActive,
  sysColorWarningAlt: tokens.color.warning.alt,
  sysColorWarningContrast: tokens.color.warning.contrast,
  sysColorSuccessMain: tokens.color.success.main,
  sysColorSuccessMainHover: tokens.color.success.mainHover,
  sysColorSuccessMainActive: tokens.color.success.mainActive,
  sysColorSuccessContrast: tokens.color.success.contrast,
  sysColorSystemMain: tokens.color.system.main,
  sysColorSystemMainHover: tokens.color.system.mainHover,
  sysColorSystemMainActive: tokens.color.system.mainActive,
  sysColorSystemContrast: tokens.color.system.contrast,
  sysColorInfoMain: tokens.color.info.main,
  sysColorInfoMainHover: tokens.color.info.mainHover,
  sysColorInfoMainActive: tokens.color.info.mainActive,
  sysColorInfoContrast: tokens.color.info.contrast,
  sysColorSpecialtyMain: tokens.color.specialty.main,
  sysColorSpecialtyMainHover: tokens.color.specialty.mainHover,
  sysColorSpecialtyMainActive: tokens.color.specialty.mainActive,
  sysColorSpecialtyContrast: tokens.color.specialty.contrast
};
export const ICON_FALLBACK_COLOR = legalColors.sysColorBackgroundHighContrast;
export const base = style({
  //@ts-ignore
  speak: 'none',
  aspectRatio: '1'
}, 'icon_base');
export const backgroundBase = style({
  display: 'inline-block',
  width: tokens.size.icon.lg,
  height: tokens.size.icon.lg
}, 'icon_background_base');
export const sizeXs = style({
  width: tokens.size.icon.xs,
  height: tokens.size.icon.xs
}, 'icon_size_xs');
export const sizeSm = style({
  width: tokens.size.icon.sm,
  height: tokens.size.icon.sm
}, 'icon_size_sm');
export const sizeMd = style({
  width: tokens.size.icon.md,
  height: tokens.size.icon.md
}, 'icon_size_md');
export const sizeLg = style({
  width: tokens.size.icon.lg,
  height: tokens.size.icon.lg
}, 'icon_size_lg');
export const sizeXl = style({
  width: tokens.size.icon.xl,
  height: tokens.size.icon.xl
}, 'icon_size_xl');
export const svg = style({
  //@ts-ignore
  speak: 'none',
  display: 'inline-block',
  aspectRatio: '1'
}, 'icon_svg');
globalStyle(`${svg} img, ${svg} svg`, {
  width: '100%',
  height: '100%',
  display: 'block'
});
__vanilla_filescope__.endFileScope();
